(() => {
  const ICONS = ['✨','⚡','🌤','❄️','🛡️','🏭','📦','🚚'];
  const DELAY = 3800;

  const initTicker = (root) => {
    if (!root || root.dataset.tpTopbarTickerReady === 'true') return;
    const bar = root.querySelector('.tp-nav__topbar');
    const link = bar?.querySelector('.tp-nav__topbar-link');
    const source = link?.querySelector(':scope > span');
    if (!bar || !link || !source) return;

    const items = source.textContent.split('||').map(v => v.trim()).filter(Boolean);
    if (!items.length) return;

    root.dataset.tpTopbarTickerReady = 'true';
    link.querySelector(':scope > svg')?.remove();

    const track = document.createElement('span');
    track.className = 'tp-nav__topbar-track';
    track.dataset.tpTopbarTrack = 'true';
    track.setAttribute('aria-live', 'off');
    source.replaceWith(track);

    let slides = [];
    let activeIndex = 0;
    let timer = 0;
    let currentGroupSize = 0;

    const desiredGroupSize = () => (bar.clientWidth >= 720 ? 2 : 1);

    const build = () => {
      const groupSize = desiredGroupSize();
      if (groupSize === currentGroupSize && slides.length) return;
      currentGroupSize = groupSize;
      track.innerHTML = '';
      slides = [];
      activeIndex = 0;

      for (let i = 0; i < items.length; i += groupSize) {
        const group = items.slice(i, i + groupSize);
        const slide = document.createElement('span');
        slide.className = `tp-nav__topbar-slide${i === 0 ? ' is-active' : ''}`;
        if (i !== 0) slide.setAttribute('aria-hidden', 'true');

        if (i === 0) {
          const badge = document.createElement('span');
          badge.className = 'tp-nav__topbar-badge';
          badge.textContent = 'NEU';
          slide.appendChild(badge);
        }

        group.forEach((text, offset) => {
          const itemIndex = i + offset;
          const feature = document.createElement('span');
          feature.className = 'tp-nav__topbar-feature';

          const icon = document.createElement('span');
          icon.className = 'tp-nav__topbar-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = ICONS[itemIndex] || '✓';

          const copy = document.createElement('span');
          copy.className = 'tp-nav__topbar-copy';
          copy.textContent = text;

          feature.append(icon, copy);
          slide.appendChild(feature);
        });

        track.appendChild(slide);
        slides.push(slide);
      }
    };

    const show = (index) => {
      if (!slides.length) return;
      activeIndex = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === activeIndex;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
    };

    const stop = () => {
      if (timer) window.clearTimeout(timer);
      timer = 0;
    };

    const schedule = () => {
      stop();
      if (document.hidden || slides.length < 2) return;
      timer = window.setTimeout(() => {
        show(activeIndex + 1);
        schedule();
      }, DELAY);
    };

    const rebuild = () => {
      const previous = currentGroupSize;
      build();
      if (previous !== currentGroupSize) {
        show(0);
        schedule();
      }
    };

    build();
    schedule();

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuild, 150);
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else schedule();
    });
  };

  const init = (scope = document) => {
    if (scope instanceof Element && scope.matches('[data-tp-navigation]')) initTicker(scope);
    scope.querySelectorAll?.('[data-tp-navigation]').forEach(initTicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
